<div fxLayout="row" fxLayoutAlign="center center" style="height: 100%; height: 100%;
    flex-direction: row;
    box-sizing: border-box;
    display: flex;
    max-height: 100%;
    place-content: center;
    align-items: center;">
    <div class="login mat-elevation-z12">
        <div class="login-header" fxLayout="column" fxLayoutAlign="center center">
          <!--  <img class="logo" src="assets/img/jasmine.png">-->
            <h1>COMPASS</h1>
        </div>
        <form>
            <div class="login-content" fxLayout="column" fxLayoutAlign="start stretch">

                <p class="note">You are logged out <br> <a [routerLink]="['/auth/login']">Sign in again</a></p>
            </div>
        </form>
    </div>
</div>

<!-- <div class="powered_by">
    <img src="assets/img/powered_by_agnext.png">
</div> -->

